import {
  createSettingsParam,
  createStylesParam,
  SettingsParamType,
  StyleParamType,
} from '@wix/tpa-settings';

import { transformSettingsKey } from '../helpers';

export const settings = {
  // @deprecated use styleParam instead
  showReactions: createSettingsParam('showReactions', {
    getDefaultValue: () => true,
    type: SettingsParamType.Boolean,
    dangerousKeyTransformationOverride: transformSettingsKey,
  }),

  // @deprecated use styleParam instead
  showShareButton: createSettingsParam('showShareButton', {
    getDefaultValue: () => true,
    type: SettingsParamType.Boolean,
    dangerousKeyTransformationOverride: transformSettingsKey,
  }),
};

export const styles = {
  showReactions: createStylesParam('showReactions', {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  }),

  showShareButton: createStylesParam('showShareButton', {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  }),

  showCreatePost: createStylesParam('showCreatePost', {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  }),
};
